export const fetchCrmInteractionDateHistogram = (request, { signal, ...data }) =>
  request({
    method: 'post',
    pathname: '/api/crm-interaction/date-histogram',
    data,
    signal,
  });

export const fetchCrmInteractionQuery = (request, { signal, ...data }) =>
  request({
    method: 'post',
    pathname: '/api/crm-interaction/query',
    data,
    signal,
  });
